import { IconCardsCollectionComponent } from './IconCardsCollection';
export default IconCardsCollectionComponent;
